import React from 'react';
import { Colors } from '@/styles/colors';

export const IncidentsFeedCount: React.FC<{ count?: number }> = ({ count }) => {
  if (!count) {
    return null;
  }
  return <div style={{ fontSize: 16, fontWeight: 400, color: Colors.Neutral }}>({count})</div>;
};
